import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

export default function LegalPage({ ns, sectionKeys }) {
  const { t } = useI18n();
  return (
    <main className="bg-slate-50">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <p className="text-xs font-semibold uppercase tracking-widest text-teal-700">
          {t(`${ns}.updated`)}
        </p>
        <h1 className="mt-3 font-jakarta text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
          {t(`${ns}.title`)}
        </h1>
        <p className="mt-6 text-base text-slate-600 leading-relaxed">
          {t(`${ns}.intro`)}
        </p>

        <div className="mt-10 space-y-8">
          {sectionKeys.map((sk) => (
            <section key={sk}>
              <h2 className="text-xl font-semibold text-slate-900">
                {t(`${ns}.sections.${sk}_title`)}
              </h2>
              <p className="mt-2 text-base text-slate-600 leading-relaxed">
                {t(`${ns}.sections.${sk}_body`)}
              </p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
